export type ReceiveQtyLine = {
  qtyPlanned: number
  qtyGood: number
  qtyDamaged: number
}

export function qtyShortageOf(line: ReceiveQtyLine): number {
  return Math.max(0, line.qtyPlanned - line.qtyGood - line.qtyDamaged)
}

export function isLineMatchPlan(line: ReceiveQtyLine): boolean {
  return line.qtyGood === line.qtyPlanned && line.qtyDamaged === 0
}

export function summarizeMatchCounts(lines: ReceiveQtyLine[]): { ok: number; diff: number } {
  let ok = 0
  for (const line of lines) {
    if (isLineMatchPlan(line)) ok += 1
  }
  return { ok, diff: lines.length - ok }
}
